export const blockIconsHomeDeviceResetNew = (
	<span className='material-symbols-outlined'>device_reset</span>
);
